export const isDebugMode = (): boolean => {
  const hostname = window.location.hostname

  return (
    hostname === 'localhost' ||
    hostname === 'dev.cybershtab.infosec.local'
  )
}